module.exports = __webpack_public_path__ + "img/bg.3182730b.png";